<script setup>
import {computed} from 'vue'

const props = defineProps({
    value: String
})

const className = computed(() => {
    const labels = {
        accepted: 'bg-warning text-dark',
        rejected: 'bg-danger',
        delivered: 'bg-success',
        failed: 'bg-danger',
        opened: 'bg-success',
        clicked: 'bg-success',
        unsubscribed: 'bg-danger',
        complained: 'bg-danger',
        stored: 'bg-warning text-dark'
    }

    if (props.value && Object.prototype.hasOwnProperty.call(labels, props.value)) {
        return labels[props.value]
    }
    return ''
})
</script>

<template>
    <span
        v-if="value"
        :class="className"
        class="badge"
        style="text-transform: capitalize"
    >{{ value }}</span>
</template>